<template>
  <div class="base-textarea form-group">
    <div
      class="px-0"
      :class="`col-${col}`">
      <b-form-textarea
        :class="fieldClass"
        :value="_value"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        :max-rows="maxRows"
        v-on="customListeners" />
    </div>
    <BaseErrorMessage :errors="errors" />
  </div>
</template>

<script>
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  name: 'BaseTextarea',
  components: {
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: [Number, String],
      default: 5
    },
    fieldClass: {
      type: String,
      default: null
    },
    maxRows: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    customListeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
      }
    }
  },
  methods: {
    onInput(input) {
      if (input !== '') {
        this.$emit('input', input)
        return
      }

      this.$emit('input', this.emptyStrToNull ? null : input)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-textarea {
  width: 100%;
  margin-bottom: 0;
}
</style>